import React, { useEffect, useState } from "react";
import "../scss/cookieConsent.scss";

const COOKIE_KEY = "itecheuropean_cookie_consent";

export default function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = window.localStorage.getItem(COOKIE_KEY);
        if (!consent) {
            setVisible(true);
        }
    }, []);

    const acceptCookies = () => {
        window.localStorage.setItem(COOKIE_KEY, "accepted");
        setVisible(false);
    };

    const ignoreCookies = () => {
        window.localStorage.setItem(COOKIE_KEY, "ignored");
        setVisible(false);
    };

    if (!visible) {
        return null;
    }

    return (
        <aside className="cookie-consent" role="dialog" aria-live="polite" aria-label="Cookie consent">
            <span className="cookie-consent__badge">Cookie Notice</span>
            <h4>We value your privacy</h4>
            <p>
                We use cookies to improve your browsing experience, personalize content, and measure website
                performance.
            </p>
            <p className="cookie-consent__disclaimer">
                Disclaimer: By clicking Accept, you agree to our use of cookies as described in our policy.
            </p>
            <div className="cookie-consent__actions">
                <button type="button" className="cookie-consent__btn cookie-consent__btn--ghost" onClick={ignoreCookies}>
                    Ignore
                </button>
                <button type="button" className="cookie-consent__btn cookie-consent__btn--primary" onClick={acceptCookies}>
                    Accept
                </button>
            </div>
        </aside>
    );
}
